import React from 'react';

import './DatePickerClearButton.scss';

type DatePickerClearButtonProps = {
  onClear: () => void;
};

export function DatePickerClearButton({ onClear }: DatePickerClearButtonProps) {
  return (
    <button
      type="button"
      className="datepicker-clear-button"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClear();
      }}
      aria-label={'Clear date picker value'}
    >
      <span />
    </button>
  );
}
